module.exports = "\n<!-- {{this.control.dirty || this.control.touched}} -->\n<ul *ngIf=\"shouldShowErrors()\" class=\"list-unstyled\">\n  <li style=\"color: #f44336; font-size: smaller;\" *ngFor=\"let error of listOfErrors()\">{{error}}</li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/helpers/show-errors/show-errors.component.html
// module id = ./src/app/helpers/show-errors/show-errors.component.html
// module chunks = main